
//Url import
import { pagePath } from '../route/pageUrl';
//공통 페이지
import { alwaysFunc } from './layout/loadData';
//서브페이지
import { favoriteFunc } from './sub/favoriteFunc';
import { biddingFunc } from './sub/biddingFunc';
import { createFunc } from './sub/createFunc';
import { settingFunc } from './sub/settingFunc';
//로그인 페이지
import { loginFunc } from './member/loginFunc';
//폼 벨리데이션 체크
import './lib/formCheck';





// WEBPACK FOOTER //
// ./js/controller/assets/assets.js